module.exports = __webpack_public_path__ + "img/pay-per-mile-rates@2x.543184fa.jpg";